import React, { useEffect, useState, useContext } from "react";
import { Container, Row, Col, Form, Table, Button } from "react-bootstrap";
import { apiGet } from "../utils/apiFetch";
import apiPath from "../utils/apiPath";
import { toast } from "wc-toast";
import { useLocation, useParams, Link } from "react-router-dom";
import ReactPaginate from "react-paginate";
import constant from "../utils/constants";
import { compact, isEmpty, startCase } from "lodash";
import AuthContext from "../context/AuthContext";
import helpers from "../utils/helpers";
import moment from "moment";
import { Helmet } from "react-helmet";
import DetailSlip from "../components/DetailSlip";

const AprofitDownline = () => {
  const parmas = useParams();
  const location = useLocation();
  const user_params = compact(location.pathname.split("/"));
  let { user } = useContext(AuthContext);
  let check = user_params[0];
  const [pageCount, setPageCount] = useState(0);
  const [viewpage, setViewPage] = useState(0);
  const [getProperty, setProperty] = useState("none");
  var previousDate = moment().subtract(1, "days").format("YYYY-MM-DD");
  var currentDate = moment().format("YYYY-MM-DD");
  const [detailsData, setDetailsData] = useState([]);

  const [filter, setFilter] = useState({
    page: 1,
    page_size: 10,
    fromPeriod: previousDate,
    toPeriod: currentDate,
    filterByDay: "",
    created_by: parmas.id ? parmas.id : user?._id,
    userType: parmas.user_type ? parmas.user_type : user?.userType,
    toPeriodTime: "09:59",
    fromPeriodTime: "10:00",
  });

  const handlePageClick = (event) => {
    setFilter((prevState) => {
      return {
        ...prevState,
        page: event.selected + 1,
      };
    });
  };

  const [select, setSelect] = useState("");
  const showDetail = async (event, id, userType) => {
    try {
      const { status, data: response_users } = await apiGet(
        apiPath.reportDownlineDetail +
          "?fromPeriod=" +
          filter.fromPeriod +
          "&toPeriod=" +
          filter.toPeriod +
          "&userId=" +
          id +
          "&userType=" +
          userType
      );
      if (status === 200) {
        if (response_users?.success) {
          setDetailsData(response_users?.results);
          setSelect(id);
          // const detailDiv = document.getElementById(id);
          // let table =
          //   '<td colSpan="6" class="abc"><table width="100%" class="sub-table">';
          // response_users.results.forEach((item, index) => {
          //   table = table + `<tr>`;
          //   table = table + `<td >${item?.username || null}</td>`;
          //   table =
          //     table +
          //     `<td>${helpers.currencyFormat(
          //       item?.stakeAmount ? item?.stakeAmount : 0
          //     )}</td>`;
          //   table =
          //     table +
          //     `<td>${
          //       Math.sign(item?.amount) !== -1
          //         ? "<span class='text-danger'>" +
          //           "(" +
          //           "-" +
          //           helpers.currencyFormat(item?.amount) +
          //           ")" +
          //           "</span>"
          //         : "<span class='text-success'>" +
          //           helpers.currencyFormat(Math.abs(item?.amount))
          //     }</span></td>`;
          //   table =
          //     table +
          //     `<td>${
          //       Math.sign(item?.amount) === -1
          //         ? "<span class='text-danger'>" +
          //           "(" +
          //           helpers.currencyFormat(item?.amount) +
          //           ")" +
          //           "</span>"
          //         : "<span class='text-success'>" +
          //           helpers.currencyFormat(Math.abs(item?.amount))
          //     }</span></td>`;
          //   table =
          //     table +
          //     `<td>${helpers.currencyFormat(item?.stake?.commission)}</td>`;
          //   table =
          //     table +
          //     `<td>${
          //       Math.sign(item?.amount) !== -1
          //         ? "<span class='text-danger'>" +
          //           "(" +
          //           "-" +
          //           helpers.currencyFormat(item?.amount) +
          //           ")" +
          //           "</span>"
          //         : "<span class='text-success'>" +
          //           helpers.currencyFormat(Math.abs(item?.amount))
          //     }</span></td>`;
          //   table += `</tr>`;
          // });
          // table += "</table></td >";

          // if (detailDiv.style.display === "none") {
          //   detailDiv.style.setProperty("display", "contents");
          //   event.target.className = "fas fa-minus-square pe-2";
          //   detailDiv.innerHTML = table;
          // } else {
          //   detailDiv.style.setProperty("display", "none");
          //   event.target.className = "fas fa-plus-square pe-2";
          // }
        }
      }
    } catch (err) {}
  };
  useEffect(() => {
    setFilter((prevState) => {
      return {
        ...prevState,
        created_by: parmas?.id,
        userType: parmas?.user_type,
      };
    });
  }, [parmas?.id]);
  const [obj, setObj] = useState({});
  const [data, setData] = useState([]);
  const [sumData, setSumData] = useState({});

  const getData = async (type = "search") => {
    if (filter.filterByDay != "") {
      if (filter.filterByDay == "today") {
        filter.fromPeriod = currentDate;
        filter.toPeriod = currentDate;
      }
      if (filter.filterByDay == "yesterday") {
        filter.fromPeriod = previousDate;
        filter.toPeriod = currentDate;
      }
    }
    let path;
    if (check == "AprofitDownline") {
      path = apiPath.reportDownline;
    } else {
      path = apiPath.reportMarket;
    }
    try {
      const { status, data: response_users } = await apiGet(
        path,
        type == "search" ? filter : type
      );
      if (status === 200) {
        if (response_users.success) {
          setData(response_users.results.data);
          setSumData(response_users.results.sumData);
          // console.log(response_users.results.data, "data");
          setPageCount(response_users.results.totalPages);
          const commission = response_users?.results?.data?.reduce((a, v) => {
            a = parseInt(a) + parseInt(v?.stake?.commission);
            return a;
          }, 0);
          const stake = response_users?.results?.data?.reduce((a, v) => {
            a = parseInt(a) + parseInt(v?.stake?.realAmount);
            return a;
          }, 0);
          const downlinePnl = response_users?.results?.data?.reduce((a, v) => {
            a = parseInt(a) + parseInt(v?.stake?.amount);
            return a;
          }, 0);
          const downlinePnlAmount = response_users?.results?.data?.reduce(
            (a, v) => {
              a = parseInt(a) + parseInt(v?.amount);
              return a;
            },
            0
          );

          setObj({
            commission: commission || 0,
            stake: stake || 0,
            downlinePnl: downlinePnl || 0,
            downlinePnlAmount: downlinePnlAmount || 0,
          });
        }
      }
    } catch (err) {
      toast.error(err.response.data.message);
    }
  };

  useEffect(() => {
    getData();
    setViewPage(filter.page ? filter.page - 1 : 0);
  }, []);

  const search = async (item) => {
    let obj = {
      page: filter.page,
      page_size: filter.page_size,
      fromPeriod: filter.fromPeriod,
      toPeriod: filter.toPeriod,
      filterByDay: filter.filterByDay,
      created_by: item._id,
      userType: item?.userType,
      toPeriodTime: filter?.toPeriodTime,
      fromPeriodTime: filter?.fromPeriodTime,
    };
    if (filter.filterByDay != "") {
      if (filter.filterByDay == "today") {
        filter.fromPeriod = currentDate;
        filter.toPeriod = currentDate;
      }
      if (filter.filterByDay == "yesterday") {
        filter.fromPeriod = previousDate;
        filter.toPeriod = currentDate;
      }
    }
    let path;
    if (check == "AprofitDownline") {
      path = apiPath.reportDownline;
    } else {
      path = apiPath.reportMarket;
    }
    try {
      const { status, data: response_users } = await apiGet(path, obj);
      if (status === 200) {
        if (response_users.success) {
          setData(response_users.results.data);
          setPageCount(response_users.results.totalPages);
          setSumData(response_users.results.sumData);
          // console.log(response_users.results.data, "data");
          const commission = response_users?.results?.data?.reduce((a, v) => {
            a = parseInt(a) + parseInt(v?.stake?.commission);
            return a;
          }, 0);
          const stake = response_users?.results?.data?.reduce((a, v) => {
            a = parseInt(a) + parseInt(v?.stake?.realAmount);
            return a;
          }, 0);
          const downlinePnl = response_users?.results?.data?.reduce((a, v) => {
            a = parseInt(a) + parseInt(v?.stake?.amount);
            return a;
          }, 0);
          const downlinePnlAmount = response_users?.results?.data?.reduce(
            (a, v) => {
              a = parseInt(a) + parseInt(v?.amount);
              return a;
            },
            0
          );

          setObj({
            commission: commission || 0,
            stake: stake || 0,
            downlinePnl: downlinePnl || 0,
            downlinePnlAmount: downlinePnlAmount || 0,
          });
        }
      }
    } catch (err) {
      toast.error(err.response.data.message);
    }
  };

  const finalPL =
    sumData?.cricketAmountPL +
    sumData?.soccerAmountPL +
    sumData?.tennisAmountPL +
    sumData?.internationalCasinoPL +
    sumData?.gapCasinoPL +
    sumData?.indianCasinoPL;
  return (
    <div>
      {/* <DetailSlip /> */}
      <section className="main-inner-outer py-4">
        <Container fluid>
          <Row>
            <div className="db-sec">
              <h2 className="common-heading">
                Profit/Loss Report by{" "}
                {check == "AprofitMarket" ? "Market" : "Downline"}
              </h2>
            </div>
            <Col md={12}>
              <div className="inner-wrapper">
                <Form className="bet_status">
                  <Row>
                    <Col xl={12} md={12}>
                      <Row>
                        <Col
                          lg={3}
                          sm={6}
                          className="mb-lg-0 mb-2 flex-grow-0 pe-2"
                        >
                          <div className="bet-sec bet-period">
                            <Form.Label className="px-2">From</Form.Label>
                            <Form.Group className="form-group">
                              <Form.Control
                                className="small_form_control"
                                onChange={(e) =>
                                  setFilter({
                                    ...filter,
                                    fromPeriod: e.target.value,
                                    filterByDay: "",
                                  })
                                }
                                max={new Date().toISOString().split("T")[0]}
                                value={filter.fromPeriod}
                                type="date"
                              />{" "}
                              <Form.Control
                                style={{ width: "80px" }}
                                className="small_form_control"
                                type="time"
                                placeholder="00:00"
                                value={filter?.fromPeriodTime}
                                onChange={(e) =>
                                  setFilter({
                                    ...filter,
                                    fromPeriodTime: e.target.value,
                                  })
                                }
                                // disabled
                              />
                            </Form.Group>
                          </div>
                        </Col>
                        <Col
                          lg={3}
                          sm={6}
                          className="mb-lg-0 mb-2 flex-grow-0 ps-2"
                        >
                          <div className="bet-sec bet-period">
                            <Form.Label className="px-2">To</Form.Label>
                            <Form.Group className="form-group">
                              <Form.Control
                                className="small_form_control"
                                onChange={(e) =>
                                  setFilter({
                                    ...filter,
                                    toPeriod: e.target.value,
                                    filterByDay: "",
                                  })
                                }
                                min={
                                  filter?.fromPeriod
                                    ? new Date(filter?.fromPeriod)
                                        .toISOString()
                                        .split("T")[0]
                                    : new Date()
                                }
                                max={new Date().toISOString().split("T")[0]}
                                value={filter.toPeriod}
                                type="date"
                              />{" "}
                              <Form.Control
                                style={{ width: "80px" }}
                                className="small_form_control"
                                type="time"
                                placeholder="00:00"
                                value={filter?.toPeriodTime}
                                onChange={(e) =>
                                  setFilter({
                                    ...filter,
                                    toPeriodTime: e.target.value,
                                  })
                                }
                              />
                            </Form.Group>
                          </div>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                  <div className="history-btn mt-2">
                    <ul className="list-unstyled mb-0">
                      <li>
                        <Button
                          className="theme_dark_btn"
                          onClick={() => getData("search")}
                        >
                          Search
                        </Button>
                      </li>
                      <li>
                        <Button
                          className="me-0 theme_light_btn"
                          onClick={() => {
                            setFilter({
                              page: 1,
                              page_size: 10,
                              fromPeriod: previousDate,
                              toPeriod: currentDate,
                              filterByDay: "",
                              created_by: parmas.id ? parmas.id : user?._id,
                              userType: parmas.user_type
                                ? parmas.user_type
                                : user?.userType,
                            });
                            getData({
                              page: 1,
                              page_size: 10,
                              fromPeriod: previousDate,
                              toPeriod: currentDate,
                              filterByDay: "",
                              created_by: parmas.id ? parmas.id : user?._id,
                              userType: parmas.user_type
                                ? parmas.user_type
                                : user?.userType,
                            });
                          }}
                        >
                          Reset
                        </Button>
                      </li>
                    </ul>
                  </div>
                </Form>
              </div>
            </Col>

            <Col md={12} sm={12} lg={12} className="mt-2">
              <section className="account-table aprofit-downline w-100">
                <div className="responsive transaction-history">
                  <Table>
                    <thead>
                      <tr>
                        <th scope="col">UID</th>
                        {check == "AprofitMarket" && (
                          <>
                            <th scope="col">Sports</th>
                            <th scope="col">Client Name</th>
                            <th scope="col">Report Type</th>
                            <th scope="col">Event Name</th>
                            <th scope="col">Report Name</th>
                            <th scope="col">Comm.</th>
                            <th scope="col">Upline/Total P/L</th>
                          </>
                        )}

                        {check !== "AprofitMarket" && (
                          <>
                            {/* <th scope="col">Stake</th> */}
                            <th scope="col">Cricket P/L</th>
                            <th scope="col">Soccer P/L</th>
                            <th scope="col">Tennis P/L</th>
                            <th scope="col">International Casino P/L</th>
                            <th scope="col">India Casino P/L</th>
                            <th scope="col">Gap Casino P/L</th>
                            {/* <th scope="col">Downline P/L</th>
                            <th scope="col">Player P/L</th>
                            <th scope="col">Comm.</th> */}
                            <th scope="col">Upline/Total P/L</th>
                          </>
                        )}
                      </tr>
                    </thead>
                    <tbody>
                      {/* const resultTotalStake = item?.bets_list?.reduce((a, v) => {
                    a = parseInt(a) + parseInt(v.amount);
                    return a;
                  }, 0); */}
                      <>
                        {data && data?.length > 0 ? (
                          data?.map((item, index) => {
                            return (
                              <>
                                <tr key={index + 1}>
                                  {check == "AprofitMarket" && (
                                    <>
                                      <td>{item._id}</td>
                                      <td>
                                        {constant.betCheckObj[item.eventType]}
                                      </td>
                                      <td>{item.clientName}</td>
                                      <td>{item.reportType}</td>
                                      <td>{item.matchName}</td>
                                      <td>{item.reportName}</td>
                                      <td>0</td>
                                      <td>
                                        {item.transactionType == "credit" ? (
                                          <span className="text-success">
                                            {`( +${helpers.currencyFormat(
                                              item.amount
                                            )} )`}
                                          </span>
                                        ) : (
                                          <span className="text-danger">
                                            {`( -${helpers.currencyFormat(
                                              item.amount
                                            )} )`}
                                          </span>
                                        )}
                                      </td>
                                    </>
                                  )}
                                  {check !== "AprofitMarket" &&
                                    (Math.abs(item?.stake?.cricketAmount) > 0 ||
                                      Math.abs(item?.stake?.soccerAmount) > 0 ||
                                      Math.abs(item?.stake?.tennisAmount) > 0 ||
                                      Math.abs(
                                        item?.stake?.internationalCasino
                                      ) > 0 ||
                                      Math.abs(item?.stake?.indianCasino) > 0 ||
                                      Math.abs(item?.stake?.gapCasino) > 0) && (
                                      <>
                                        <td className="text-start">
                                          {item?.userType == "user" ? (
                                            <>
                                              <a
                                                href={"#"}
                                                className="text-primary"
                                              >
                                                <span>
                                                  {
                                                    constant?.user_status[
                                                      item?.userType || ""
                                                    ]
                                                  }
                                                </span>
                                              </a>
                                              {item?.username || null}
                                            </>
                                          ) : (
                                            <>
                                              {/* <i
                                              id={"icon_" + item?._id}
                                              className="fas fa-plus-square pe-2"
                                              onClick={(e) =>
                                                showDetail(
                                                  e,
                                                  item?._id,
                                                  item?.userType
                                                )
                                              }
                                            ></i> */}
                                              <Link
                                                to={`/AprofitDownline/${item._id}/${item?.userType}`}
                                                onClick={() => search(item)}
                                              >
                                                <span>
                                                  {
                                                    constant?.user_status[
                                                      item?.userType || ""
                                                    ]
                                                  }
                                                </span>
                                                {item?.username || null}
                                              </Link>
                                            </>
                                          )}
                                        </td>
                                        {/* <td>
                                        {helpers.currencyFormat(
                                          item?.stakeAmount
                                        )}
                                      </td> */}

                                        <td>
                                          {" "}
                                          {Math.sign(
                                            item?.stake?.cricketAmount || 0
                                          ) === -1 ? (
                                            <span className="text-danger">
                                              (
                                              {helpers.currencyFormat(
                                                item?.stake?.cricketAmount || 0
                                              )}
                                              )
                                            </span>
                                          ) : (
                                            <span className="text-success">
                                              {helpers.currencyFormat(
                                                item?.stake?.cricketAmount || 0
                                              )}
                                            </span>
                                          )}
                                        </td>
                                        <td>
                                          {" "}
                                          {Math.sign(
                                            item?.stake?.soccerAmount || 0
                                          ) === -1 ? (
                                            <span className="text-danger">
                                              (
                                              {helpers.currencyFormat(
                                                item?.stake?.soccerAmount || 0
                                              )}
                                              )
                                            </span>
                                          ) : (
                                            <span className="text-success">
                                              {helpers.currencyFormat(
                                                item?.stake?.soccerAmount || 0
                                              )}
                                            </span>
                                          )}
                                        </td>
                                        <td>
                                          {" "}
                                          {Math.sign(
                                            item?.stake?.tennisAmount || 0
                                          ) === -1 ? (
                                            <span className="text-danger">
                                              (
                                              {helpers.currencyFormat(
                                                item?.stake?.tennisAmount || 0
                                              )}
                                              )
                                            </span>
                                          ) : (
                                            <span className="text-success">
                                              {helpers.currencyFormat(
                                                item?.stake?.tennisAmount || 0
                                              )}
                                            </span>
                                          )}
                                        </td>
                                        <td>
                                          {Math.sign(
                                            item?.stake?.internationalCasino ||
                                              0
                                          ) === -1 ? (
                                            <span className="text-danger">
                                              (
                                              {helpers.currencyFormat(
                                                item?.stake
                                                  ?.internationalCasino || 0
                                              )}
                                              )
                                            </span>
                                          ) : (
                                            <span className="text-success">
                                              {helpers.currencyFormat(
                                                item?.stake
                                                  ?.internationalCasino || 0
                                              )}
                                            </span>
                                          )}
                                        </td>
                                        <td>
                                          {Math.sign(
                                            item?.stake?.indianCasino || 0
                                          ) === -1 ? (
                                            <span className="text-danger">
                                              (
                                              {helpers.currencyFormat(
                                                item?.stake?.indianCasino || 0
                                              )}
                                              )
                                            </span>
                                          ) : (
                                            <span className="text-success">
                                              {helpers.currencyFormat(
                                                item?.stake?.indianCasino || 0
                                              )}
                                            </span>
                                          )}
                                        </td>
                                        <td>
                                          {Math.sign(
                                            item?.stake?.gapCasino || 0
                                          ) === -1 ? (
                                            <span className="text-danger">
                                              (
                                              {helpers.currencyFormat(
                                                item?.stake?.gapCasino || 0
                                              )}
                                              )
                                            </span>
                                          ) : (
                                            <span className="text-success">
                                              {helpers.currencyFormat(
                                                item?.stake?.gapCasino || 0
                                              )}
                                            </span>
                                          )}
                                        </td>
                                        <td>
                                          {Math.sign(
                                            item?.stake?.amount || 0
                                          ) == -1 ? (
                                            // <span className="text-danger">
                                            //   (
                                            //   {helpers.currencyFormat(
                                            //     item?.stake?.amount || 0
                                            //   )}
                                            //   )
                                            // </span>
                                            <span className="text-success">
                                              {helpers.currencyFormat(
                                                Math.abs(item?.stake?.amount)
                                              )}
                                            </span>
                                          ) : (
                                            // <span className="text-success">
                                            //   {helpers.currencyFormat(
                                            //     Math.abs(
                                            //       item?.stake?.amount || 0
                                            //     )
                                            //   )}
                                            // </span>
                                            <span className="text-danger">
                                              -
                                              {helpers.currencyFormat(
                                                Math.abs(
                                                  item?.stake?.amount || 0
                                                )
                                              )}
                                            </span>
                                          )}
                                        </td>
                                      </>
                                    )}
                                </tr>
                                {detailsData?.data?.length > 0 &&
                                  select == item?._id && (
                                    <tr
                                      className=""
                                      id={item?._id}
                                      // style={{ display: getProperty }}
                                      key={item?._id}
                                    >
                                      <td colSpan="6" class="abc">
                                        <table width="100%" class="sub-table">
                                          {detailsData?.data?.map((itemNew) => {
                                            return (
                                              <tr>
                                                <td>
                                                  {itemNew?.username || null}
                                                </td>
                                                <td>
                                                  {helpers.currencyFormat(
                                                    itemNew?.stakeAmount
                                                      ? itemNew?.stakeAmount
                                                      : 0
                                                  )}
                                                </td>
                                                <td>
                                                  {Math.sign(
                                                    itemNew?.amount
                                                  ) !== -1 ? (
                                                    <span class="text-danger">
                                                      {helpers.currencyFormat(
                                                        itemNew?.amount
                                                      )}
                                                    </span>
                                                  ) : (
                                                    <span class="text-success">
                                                      {helpers.currencyFormat(
                                                        Math.abs(
                                                          itemNew?.amount
                                                        )
                                                      )}
                                                    </span>
                                                  )}
                                                </td>
                                                <td>
                                                  {Math.sign(
                                                    itemNew?.amount
                                                  ) === -1 ? (
                                                    <span class="text-danger">
                                                      {itemNew?.amount > 0
                                                        ? helpers.currencyFormat(
                                                            itemNew?.amount
                                                          )
                                                        : 0}
                                                    </span>
                                                  ) : (
                                                    <span class="text-success">
                                                      {itemNew?.amount > 0
                                                        ? helpers.currencyFormat(
                                                            Math.abs(
                                                              itemNew?.amount
                                                            )
                                                          )
                                                        : 0}
                                                    </span>
                                                  )}
                                                </td>
                                                <td>
                                                  {helpers.currencyFormat(
                                                    itemNew?.stake?.commission
                                                  )}
                                                </td>
                                                <td>
                                                  {Math.sign(
                                                    itemNew?.amount
                                                  ) !== -1 ? (
                                                    <span class="text-danger">
                                                      {helpers.currencyFormat(
                                                        itemNew?.amount
                                                      )}
                                                    </span>
                                                  ) : (
                                                    <span class="text-success">
                                                      {helpers.currencyFormat(
                                                        Math.abs(
                                                          itemNew?.amount
                                                        )
                                                      )}
                                                    </span>
                                                  )}
                                                </td>
                                              </tr>
                                            );
                                          })}
                                        </table>
                                      </td>
                                    </tr>
                                  )}
                              </>
                            );
                          })
                        ) : (
                          <tr>
                            <td colSpan={12}>
                              <span>You have no bets in this time period.</span>
                            </td>
                          </tr>
                        )}
                        {data && data?.length > 0 && (
                          <>
                            {check == "AprofitMarket" && (
                              <tr>
                                <th scope="col">Total</th>
                                <th scope="col"></th>
                                <th scope="col"></th>
                                <th scope="col"></th>
                                <th scope="col"></th>
                                <th scope="col"></th>
                                <th scope="col"></th>
                                <th scope="col">
                                  {Math.sign(obj.downlinePnlAmount) === -1 ? (
                                    <span className="text-danger">
                                      {helpers.currencyFormat(
                                        Math.abs(obj.downlinePnlAmount)
                                      )}
                                    </span>
                                  ) : (
                                    <span className="text-success">
                                      (
                                      {helpers.currencyFormat(
                                        obj.downlinePnlAmount
                                      )}
                                      )
                                    </span>
                                  )}
                                </th>
                              </tr>
                            )}
                            {check !== "AprofitMarket" && (
                              <tr>
                                <th scope="col">Total</th>
                                {/* <th scope="col">
                                  {" "}
                                  {helpers.currencyFormat(sumData?.stakeAmount)}
                                </th> */}
                                <th scope="col">
                                  {Math.sign(sumData?.cricketAmountPL) == -1 ? (
                                    <span className="text-danger">
                                      (
                                      {helpers.currencyFormat(
                                        sumData?.cricketAmountPL || 0
                                      )}
                                      )
                                    </span>
                                  ) : (
                                    <span className="text-success">
                                      {helpers.currencyFormat(
                                        Math.abs(sumData?.cricketAmountPL || 0)
                                      )}
                                    </span>
                                  )}
                                </th>
                                <th scope="col">
                                  {Math.sign(sumData?.soccerAmountPL || 0) ==
                                  -1 ? (
                                    <span className="text-danger">
                                      (
                                      {helpers.currencyFormat(
                                        sumData?.soccerAmountPL || 0
                                      )}
                                      )
                                    </span>
                                  ) : (
                                    <span className="text-success">
                                      {helpers.currencyFormat(
                                        Math.abs(sumData?.soccerAmountPL || 0)
                                      )}
                                    </span>
                                  )}
                                </th>
                                <th scope="col">
                                  {Math.sign(sumData?.tennisAmountPL || 0) ==
                                  -1 ? (
                                    <span className="text-danger">
                                      (
                                      {helpers.currencyFormat(
                                        sumData?.tennisAmountPL || 0
                                      )}
                                      )
                                    </span>
                                  ) : (
                                    <span className="text-success">
                                      {helpers.currencyFormat(
                                        Math.abs(sumData?.tennisAmountPL || 0)
                                      )}
                                    </span>
                                  )}
                                </th>
                                <th scope="col">
                                  {Math.sign(
                                    sumData?.internationalCasinoPL || 0
                                  ) === -1 ? (
                                    <span className="text-danger">
                                      (
                                      {helpers.currencyFormat(
                                        sumData?.internationalCasinoPL || 0
                                      )}
                                      )
                                    </span>
                                  ) : (
                                    <span className="text-success">
                                      {helpers.currencyFormat(
                                        Math.abs(
                                          sumData?.internationalCasinoPL || 0
                                        )
                                      )}
                                    </span>
                                  )}
                                </th>
                                <th scope="col">
                                  {Math.sign(sumData?.indianCasinoPL || 0) ===
                                  -1 ? (
                                    <span className="text-danger">
                                      (
                                      {helpers.currencyFormat(
                                        sumData?.indianCasinoPL || 0
                                      )}
                                      )
                                    </span>
                                  ) : (
                                    <span className="text-success">
                                      {helpers.currencyFormat(
                                        Math.abs(sumData?.indianCasinoPL || 0)
                                      )}
                                    </span>
                                  )}
                                </th>
                                <th scope="col">
                                  {Math.sign(sumData?.gapCasinoPL || 0) ===
                                  -1 ? (
                                    <span className="text-danger">
                                      (
                                      {helpers.currencyFormat(
                                        sumData?.gapCasinoPL || 0
                                      )}
                                      )
                                    </span>
                                  ) : (
                                    <span className="text-success">
                                      {helpers.currencyFormat(
                                        Math.abs(sumData?.gapCasinoPL || 0)
                                      )}
                                    </span>
                                  )}
                                </th>
                                <th scope="col">
                                  {Math.sign(finalPL) == -1 ? (
                                    <span className="text-success">
                                      {helpers.currencyFormat(
                                        Math.abs(finalPL)
                                      )}
                                    </span>
                                  ) : (
                                    <span className="text-danger">
                                      -
                                      {helpers.currencyFormat(
                                        Math.abs(finalPL)
                                      )}
                                    </span>
                                  )}
                                </th>
                              </tr>
                            )}
                          </>
                        )}
                      </>
                    </tbody>
                  </Table>
                  <div className="bottom-pagination">
                    <ReactPaginate
                      breakLabel="..."
                      nextLabel=" >"
                      forcePage={viewpage}
                      onPageChange={handlePageClick}
                      pageRangeDisplayed={10}
                      pageCount={pageCount}
                      previousLabel="< "
                      renderOnZeroPageCount={null}
                      activeClassName="p-0"
                      activeLinkClassName="pagintion-li"
                    />
                  </div>
                </div>
              </section>
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  );
};

export default AprofitDownline;
